import { combineReducers } from 'redux';
import {
  byIdReducerTemplate,
  entityAllIdsReducerTemplate,
} from '../reducerUtils';

export default combineReducers({
  byId: byIdReducerTemplate('questions'),
  allids: entityAllIdsReducerTemplate('questions'),
});



// WEBPACK FOOTER //
// ./src/reducers/entities/questionsReducer.js